function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.60234 2.39984C5.39018 2.39986 5.18671 2.48415 5.03668 2.63418C4.88666 2.7842 4.80237 2.98767 4.80234 3.19984V13.5998H6.40234V3.99984H19.2023V17.5998C19.2023 18.9346 18.1371 19.9998 16.8023 19.9998C15.4676 19.9998 14.4023 18.9346 14.4023 17.5998V15.9998C14.4023 15.7877 14.318 15.5842 14.168 15.4342C14.018 15.2842 13.8145 15.1999 13.6023 15.1998H3.20234C2.99018 15.1999 2.78671 15.2842 2.63668 15.4342C2.48666 15.5842 2.40236 15.7877 2.40234 15.9998V17.5998C2.40234 19.7995 4.20273 21.5998 6.40234 21.5998H16.8023C16.829 21.5996 16.8556 21.598 16.882 21.5952C19.0449 21.5519 20.8023 19.7726 20.8023 17.5998V3.19984C20.8023 2.98767 20.718 2.7842 20.568 2.63418C20.418 2.48415 20.2145 2.39986 20.0023 2.39984H5.60234Z",
  fill: "#201858"
});

var SvgPaper = function SvgPaper(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaper, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paper.bd6d60b0.svg";
export { ForwardRef as ReactComponent };